import { ConfirmProvider } from '@app/providers/ConfirmProvider';
import { ToastProvider } from '@app/providers/ToastProvider';
import { AuthProvider } from '@app/providers/AuthProvider';
import { UrQlProvider } from '@app/providers/UrQlProvider';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from '@shared/lib/sentry';
import ReactDOM from 'react-dom/client';
import '@app/styles/variables.css';
import '@app/styles/normalize.css';
import '@shared/tokens/fonts.css';
import App from '@app/app';
import React from 'react';

// Инициализация Sentry для мониторинга ошибок
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <ConfirmProvider>
            <UrQlProvider>
              <App />
            </UrQlProvider>
          </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
